export default "__VITE_ASSET__CxEZb$dk__"